/* Lala — lightweight interactions (reveal on scroll, tabs, size guide dialog) */
(function () {
  function initReveal(root) {
    var els = (root || document).querySelectorAll('.lala-reveal:not(.is-in)');
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-in');
          io.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    els.forEach(function (el) { io.observe(el); });
  }

  function initTabs(root) {
    (root || document).querySelectorAll('[data-lala-tabs]').forEach(function (wrap) {
      if (wrap.dataset.bound) return;
      wrap.dataset.bound = '1';
      var tabs = wrap.querySelectorAll('[role="tab"]');
      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          tabs.forEach(function (t) {
            var selected = t === tab;
            t.setAttribute('aria-selected', selected ? 'true' : 'false');
            t.tabIndex = selected ? 0 : -1;
            var panel = wrap.querySelector('#' + t.getAttribute('aria-controls'));
            if (panel) panel.hidden = !selected;
          });
          var link = wrap.querySelector('[data-lala-tab-link]');
          if (link && tab.dataset.url) link.href = tab.dataset.url;
        });
        tab.addEventListener('keydown', function (e) {
          if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
          var list = Array.prototype.slice.call(tabs);
          var i = list.indexOf(tab) + (e.key === 'ArrowRight' ? 1 : -1);
          var next = list[(i + list.length) % list.length];
          next.focus();
          next.click();
        });
      });
    });
  }

  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-lala-dialog-open]');
    if (opener) {
      var dlg = document.getElementById(opener.getAttribute('data-lala-dialog-open'));
      if (dlg && dlg.showModal) { e.preventDefault(); dlg.showModal(); }
      return;
    }
    if (e.target.closest('[data-lala-dialog-close]')) {
      var d = e.target.closest('dialog');
      if (d) d.close();
      return;
    }
    if (e.target.tagName === 'DIALOG' && e.target.classList.contains('lala-dialog')) e.target.close();
  });

  function init(root) { initReveal(root); initTabs(root); }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
